import React from "react";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { SETTINGS_BASE_PATH, SETTINGS_SECTIONS } from "../../constants";
import {
  Nav,
  NavLink,
  NavRow,
  IconBox,
  TextBox,
  RowTitle,
  RowSubtitle,
  Chevron,
} from "./styles";
import { SettingsNavProps } from "./types";

export const SettingsNav: React.FC<SettingsNavProps> = ({ activeSection }) => {
  return (
    <Nav aria-label="Settings">
      {SETTINGS_SECTIONS.map((section) => {
        const isActive = section.id === activeSection;
        const Icon = section.icon;
        const href = `${SETTINGS_BASE_PATH}/${section.id}`;

        return (
          <NavLink key={section.id} href={href}>
            <NavRow
              $isActive={isActive}
              aria-current={isActive ? "page" : undefined}
            >
              <IconBox>
                <Icon />
              </IconBox>
              <TextBox>
                <RowTitle>{section.label}</RowTitle>
                <RowSubtitle>{section.subtitle}</RowSubtitle>
              </TextBox>
              <Chevron>
                <ChevronRight />
              </Chevron>
            </NavRow>
          </NavLink>
        );
      })}
    </Nav>
  );
};
